{
    "welcome": "Vitajte v systéme SOČ, {name}",
    "new_account": "Vytvoriť nový účet",
    "footer": {
        "copyright": "© {year} ŠIOV - Štátny inštitút odborného vzdelávania. Všetky práva vyhradené.",
        "privacy_policy": "Ochrana súkromia",
        "report_bug": "Nahlásiť chybu",
        "contact": "Kontakt"
    },
    "bug_report": {
        "title": "Nahlásiť chybu",
        "subject": "Predmet",
        "description": "Popis",
        "submit": "Odoslať",
        "submitting": "Odosielanie..."
    },
    "create_missing_round": {
        "title": "Školské súťažné kolo sa nenašlo",
        "description": "Pre zaradenie prihlášky do súťaže je potrebné školské súťažné kolo, z ktorého následne môže prihláška postupovať vyššie. Systém môže pre Vás toto kolo automaticky vytvoriť a nasledujúce prihlášky už budú priamo zaraďované doň.",
        "confirm": "Vytvoriť",
        "confirming": "Vytváranie..."
    },
    "round_already_started": {
        "title": "Súťažné kolo už začalo",
        "description": "Pre zaradenie prihlášky do súťažného kola musí byť dané súťažné kolo pred začatím. Po začatí kolo už nové prihlášky neprijíma. Kliknutím na tlačidlo nižšie môžete súťažné kolo zobraziť.",
        "confirm": "Zobraziť",
        "time": "začalo",
        "span": "Prebieha"
    },
    "round_already_ended": {
        "title": "Súťažné kolo už skončilo",
        "description": "Pre zaradenie prihlášky do súťažného kola musí byť dané súťažné kolo pred začatím. Po začatí kolo už nové prihlášky neprijíma. Kliknutím na tlačidlo nižšie môžete súťažné kolo zobraziť.",
        "confirm": "Zobraziť",
        "time": "skončilo",
        "span": "Prebiehalo"
    },
    "version": "Verzia",
    "paper_nudge": "Prihlášku do súťaže si si zatiaľ nepodal.",
    "coauthors_placeholder": "Zadajte email užívateľa na pridanie...",
    "updated_at": "Aktualizované {0}",
    "error_desc": {
        "503": "Momentálne prebieha na našich serveroch údržba. Prosím, skúste to zopakovať neskôr.",
        "500": "Server vrátil chybu",
        "404": "Stránka, ktorú hľadáte, nebola nájdená",
        "403": "Na zobrazenie tejto stránky nemáte dostatočné práva",
        "unknown": "Neznáma chyba"
    },
    "stat_categories": {
        "title": "Štatistika",
        "participating_schools": "Zapojení študenti",
        "school_activity": "Aktivita škôl",
        "most_active_schools": "Školy podľa aktivity",
        "category_participation": "Zapojenosť v odboroch",
        "local": "Školské kolá",
        "region": "Krajské kolo",
        "nationwide": "Celoštátne kolo",
        "complete_activity": "Kompletná štatistika zapojenosti"
    },
    "dashboard": {
        "student": {
            "date_by": {
                "title": "Dátum odovzdania prihlášky",
                "desc_one": "Prihlášku je potrebné odovzdať do",
                "desc_two": "Ostáva vám ešte nasledovný počet dní"
            },
            "contact": {
                "title": "Kontaktné informácie",
                "desc_one": "Meno: ",
                "desc_two": "Email: "
            }
        },
        "garant": {
            "unapproved_papers": {
                "title": "Prihlášky na schválenie",
                "desc": "Prihlášky vašich študentov čakajúce na schálenie garantom nájdete v zložke "
            },
            "students": {
                "title": "Prihlásení študenti",
                "desc": "Počet študentov, ktorí sa k vám pre tento ročník súťaže prihlásili. Spravovať ich môžte v zložke "
            }
        },
        "judge": {
            "papers_to_review": {
                "title": "Prihlášky na ohodnotenie",
                "desc": "Prihlášky študentov čakajúce na ohodnotenie nájdete v zložke "
            }
        },
        "roles": {
            "garant": {
                "title": "Garant",
                "desc": "V tomto ročníku súťaže ste garantom za ",
                "levels_few": "{0} subjekty",
                "levels_many": "{0} subjektov"
            },
            "vsk": {
                "title": "Vedúci súťažného kola",
                "desc": "V tomto ročníku súťaže ste vedúcim súťažného kola pre "
            },
            "judge": {
                "title": "Porotca",
                "desc": "V tomto ročníku súťaže ste porotcom pre ",
                "desc_2": " {category_word} v ",
                "desc_3": " {round_word}",
                "category_single": "kategóriu",
                "category_more": "kategórie",
                "category_multi": "kategórií",
                "round_single": "kole",
                "round_multi": "kolách"
            },
            "admin": {
                "title": "Administrátor",
                "desc": "Ste administrátorom systému SOČ"
            }
        }
    },
    "view": "Zobraziť",
    "form": {
        "name": "Meno",
        "last_name": "Priezvisko",
        "name_accent": "Meno (uvádzajte s diakritikou)",
        "last_name_accent": "Priezvisko (uvádzajte s diakritikou)",
        "email": "Email",
        "phone_number": "Telefónne číslo",
        "date_of_birth": "Dátum narodenia",
        "school": "Škola",
        "grade": "Ročník",
        "street": "Ulica a číslo domu",
        "city": "Mesto",
        "zipcode": "PSČ",
        "password": "Heslo",
        "password_confirmation": "Potvrdiť heslo",
        "remember_me": "Zostať prihlásený",
        "forgotten_password": "Zabudnuté heslo?",
        "login": "Prihlásiť sa",
        "change_password": "Zmeniť heslo",
        "contest_rounds": "Súťažné kolá",
        "search_contest_rounds": "Hľadať súťažné kolá...",
        "already_registered": "Už máte účet?",
        "register": "Zaregistrovať sa",
        "select_date": "Vybrať dátum",
        "old_password": "Staré heslo",
        "new_password": "Nové heslo",
        "new_password_confirmation": "Potvrdiť nové heslo",
        "reset_password": "Obnoviť heslo",
        "create_password": "Vytvoriť heslo",
        "region": "Kraj",
        "basic_info": "Základné informácie",
        "start_date": "Dátum od",
        "end_date": "Dátum do",
        "roles_perms": "Role a právomoci",
        "roles": "Role",
        "permissions": "Právomoci",
        "user_activity": "Aktivita",
        "account_created_at": "Dátum a čas registrácie",
        "email_verified_at": "Dátum a čas overenia emailu",
        "email_unverified": "Email nebol overený",
        "school_or_county": "Priradené školy a okresy",
        "county": "Okres",
        "order": "Poradie",
        "address": "Adresa",
        "select_grade": "Vyberte ročník",
        "user": "Užívateľ"
    },
    "paper_form": {
        "name": "Názov",
        "contest_year": "Súťaž",
        "contest_category_id": "Súťažný odbor",
        "authors": "Autori",
        "author": "Autor",
        "coauthors": "Spoluautori",
        "more_info": "Doplnkové informácie",
        "required_equipment": "Požiadavky na výpočtovú a audiovizuálnu techniku pri obhajobe",
        "required_equipment_short": "Požiadavky na techniku pri obhajobe",
        "annotation": "Anotácia, popis práce",
        "local_annotation": "Po slovensky",
        "english_annotation": "Po anglicky",
        "main_info": "Hlavné údaje o práci",
        "keywords": "Kľúčové slová",
        "appendix": "Príloha práce",
        "result_evaluation": "Zhodnotenie výsledku, prínos práce",
        "references": "Referencie o autorovi",
        "contests": "Účasť v iných súťažiach (názov, dátum, umiestnenie)",
        "attachments": "Príloha - nahrávanie súboru",
        "file_id": "Práca",
        "attachment_id": "Voliteľná príloha",
        "select": {
            "contest_years": "Vyber súťaž",
            "contest_categories": "Vyberte odbor",
            "rating": "Vyberte hodnotenie"
        },
        "submit": {
            "title": "Odovzdať prihlášku?",
            "detail": "Kliknutím na tlačidlo nižšie závazne potvrdíte odovzdanie prihlášky. Táto voľba sa nedá vrátiť späť. Prihlášky bude po odovzdaní poslaná garantovi, ktorý má možnosť ju pred schválením ešte dodatočne upraviť.",
            "submit": "Odovzdať",
            "submitting": "Odovzdávanie..."
        },
        "school": "Škola",
        "action": {
            "submit": "Odovzdať do",
            "approve": "Schváliť do",
            "review": "Ohodnotiť do"
        },
        "status": {
            "school": "Školské kolo",
            "county": "Okresné kolo",
            "region": "Krajské kolo",
            "nationwide": "Celoštátne kolo"
        },
        "contest_round": "Súťažné kolo",
        "rating": "Hodnotenie"
    },
    "paper_ratings": {
        "FIRST_PLACE": "Prvé miesto",
        "SECOND_PLACE": "Druhé miesto",
        "THIRD_PLACE": "Tretie miesto",
        "FOURTH_PLACE": "Štvrté miesto",
        "FIFTH_PLACE": "Piate miesto",
        "SUCCESSFUL": "Úspešný riešiteľ",
        "INVALID": "Neúspešný riešiteľ",
        "DID_NOT_PARTICIPATE": "Nezúčastnil sa"
    },
    "paper_ratings_badge": {
        "FIRST_PLACE": "1. miesto",
        "SECOND_PLACE": "2. miesto",
        "THIRD_PLACE": "3. miesto",
        "FOURTH_PLACE": "4. miesto",
        "FIFTH_PLACE": "5. miesto",
        "SUCCESSFUL": "Úspešná",
        "INVALID": "Neúspešná",
        "UNKNOWN": "Neohodnotená",
        "DID_NOT_PARTICIPATE": "Nezúčastnil sa"
    },
    "paper_ratings_short": {
        "FIRST_PLACE": "1. miesto",
        "SECOND_PLACE": "2. miesto",
        "THIRD_PLACE": "3. miesto",
        "FOURTH_PLACE": "4. miesto",
        "FIFTH_PLACE": "5. miesto",
        "SUCCESSFUL": "Úspešná",
        "INVALID": "Neúspešná",
        "UNKNOWN": "Neohodnotená",
        "DID_NOT_PARTICIPATE": "Nezúčast."
    },
    "reuse_cert_button_tooltip": "Použiť šablónu z predošlého ročníka",
    "judge_form": {
        "contest_categories": "Súťažné odbory",
        "search_contest_categories": "Hľadať súťažné odbory..."
    },
    "garant_form": {
        "search_levels": "Hľadať školy a okresy..."
    },
    "round_form": {
        "contest_year": "Súťaž",
        "level": "Úroveň",
        "select_level": "Vyber úroveň",
        "tooltips": {
            "start_date": "Dátum začiatku kola, do ktorého je možné zaraďovať prihlášky vrátane daného dňa. Nasledujúcim dňom už kolo nové prihlášky neprijíma a začína sa fáza hodnotenia, kedy porotcovia prihlášky ohodnotia a tie môžu byť garantmi ďalej posunuté do vyšších kôl.",
            "end_date": "Dátum konca kola, do ktorého je možné zaradené prihlášky hodnotiť vrátane daného dňa. Počnúc nasledujúcim dňom už nie je možné prihlášky hodnotiť ani posúvať ďalej."
        },
        "starts_in": "Kolo začína {0}",
        "ends_in": "Kolo končí {0}",
        "ended": "Kolo skončilo {0}",
        "assign_judge": "Zadajte email porotcu na pridelenie...",
        "diploma_template": "Šablóna diplomov",
        "certificate_template": "Šablóna certifikátov",
        "finish_list_template": "Šablóna výsledkovej listiny",
        "start_date": "Dátum ukončenia odovzdávania prihlášok a začiatku hodnotenia",
        "end_date": "Dátum ukončenia kola / ukončenia hodnotenia prác",
        "name_autocomplete": "(Doplní sa automaticky)",
        "name_prefix": "Školské kolo",
        "reviewers": {
            "email_placeholder": "Zadajte email porotcu"
        }
    },
    "year_form": {
        "certificate_template": "Šablóna certifikátov",
        "finish_list_template": "Šablóna výsledkovej listiny",
        "tooltips": {
            "order": "Poradie ročníka v histórii konania súťaže SOČ. Toto číslo je zobrazené na vygenerovaných certifikátoch systémom.",
            "start_date": "Všetky súťažné kolá v tomto súťažnom ročníku musia začínať najskôr dátumom začiatku ročníka a nie skorej.",
            "end_date": "Všetky súťažné kolá v tomto súťažnom ročníku musia končiť najneskôr dátumom konca ročníka a nie neskôr."
        }
    },
    "paper_tabs": {
        "main": "Obsah",
        "info": "Informácie",
        "files": "Súbory",
        "history": "História",
        "ratings": "Hodnotenia"
    },
    "round_tabs": {
        "round": "Kolo",
        "papers": "Prihlášky",
        "participants": "Účastníci",
        "ratings": "Výsledky"
    },
    "contest_year_tabs": {
        "contest_year": "Ročník",
        "rounds": "Kolá"
    },
    "school_form": {
        "basic_info": "Všeobecné údaje",
        "garants": "Garanti školy"
    },
    "school_tabs": {
        "main": "Informácie",
        "garants": "Garanti"
    },
    "generic": {
        "name": "Názov",
        "long_name": "Celý názov",
        "email": "Email",
        "level": "Úroveň",
        "start_date": "Začiatok",
        "end_date": "Koniec",
        "status": "Stav",
        "round": "{0} kolo {1}",
        "author_name": "Meno Autora",
        "author_last_name": "Priezvisko Autora",
        "author_email": "Email Autora",
        "school": "Škola",
        "category": "Odbor",
        "back": "Späť",
        "search": "Hľadať...",
        "grade": "{grade}. ročník",
        "person_name": "Meno",
        "roles": "Role",
        "description": "Popis",
        "slug": "Skratka",
        "system": "Systém",
        "address": "Adresa",
        "city": "Mesto",
        "paper_name": "Názov práce",
        "rating": "Hodnotenie",
        "judge_name": "Porotca",
        "coauthors": "Spoluautori"
    },
    "round_status": {
        "upcoming": "Nadchádzajúce",
        "in_progress": "Prebieha",
        "ended": "Ukončené"
    },
    "paper_status": {
        "draft": "Návrh",
        "submitted": "Odovzdaná",
        "unapproved": "Čaká na schválenie"
    },
    "level": {
        "school": "Školské",
        "district": "Obvodné",
        "county": "Okresné",
        "subregion": "Regionálne",
        "region": "Krajské",
        "nationwide": "Celoštátne"
    },
    "navbar": {
        "login": "Prihlásiť sa",
        "dashboard": "Domov",
        "papers": "Prihlášky",
        "rounds": "Kolá",
        "judges": "Porotcovia",
        "garants": "Garanti",
        "vsks": "VSK",
        "round_managers": "Správcovia CK",
        "contest_years": "Ročníky",
        "users": "Užívatelia",
        "dropdown": {
            "profile": "Profil",
            "change_password": "Zmeniť heslo",
            "settings": "Nastavenia",
            "logout": "Odhlásiť sa",
            "admin": {
                "title": "Systém",
                "configuration": "Nastavenia",
                "contacts": "Kontaktné osoby",
                "mass-email": "Hromadný email"
            }
        },
        "students": "Študenti",
        "schools": "Školy"
    },
    "pages": {
        "welcome": "Vitajte",
        "login": "Prihlásenie",
        "register": "Registrácia",
        "forgot_password": "Zabudnuté heslo",
        "reset_password": "Obnova hesla",
        "create_password": "Vytvorenie hesla",
        "dashboard": "Domov",
        "papers": "Prihlášky",
        "rounds": "Súťažné kolá",
        "contest_years": "Ročníky súťaže",
        "create_contest_year": "Vytvoriť ročník súťaže",
        "create_contest_round": "Vytvoriť súťažné kolo",
        "update_round": "Súťažné kolo",
        "create_paper": "Prihláška do SOČ",
        "judges": "Porotcovia",
        "create_judge": "Vytvoriť porotcu",
        "garants": "Garanti",
        "create_garant": "Vytvoriť Garanta",
        "vsks": "Vedúci súťažných kôl",
        "create_vsk": "Vytvoriť Vedúceho krajského kola",
        "verify_email": "Overenie emailovej adresy",
        "confirm_password": "Potvrdenie hesla",
        "change_password": "Zmena hesla",
        "profile": "Profil užívateľa {user}",
        "users": "Užívatelia",
        "user": "Užívateľ {user}",
        "students": "Študenti",
        "settings": "Nastavenia",
        "about": "O aplikácii SOČ",
        "licenses": "Licencie",
        "error": "Chyba serveru",
        "schools": "Školy",
        "create_user": "Vytvoriť užívateľa",
        "contacts": "Kontakty",
        "create_contact": "Vytvoriť kontakt",
        "round-managers": "Správcovia celoštátnych kôl",
        "create_round_manager": "Vytvoriť Správcu celoštátneho kola",
        "template_guide": "Návod na použitie šablón diplomov a certifikátov",
        "mass-email": "Hromadný email",
        "verify-certificate": "Overenie certifikátu SOČ",
        "certificate-valid": "Platný certifikát"
    },
    "errors": {
        "invalid_credentials": "Nesprávne prihlasovacie údaje"
    },
    "profile_form": {
        "title": "Profil",
        "student_profile": "Údaje študenta",
        "judge_profile": "Údaje porotcu",
        "garant_profile": "Údaje garanta",
        "vsk_profile": "Údaje VSK"
    },
    "empty_table": "Žiadne údaje",
    "forgot_password": {
        "desc": "Zabudli ste svoje heslo? Bez obáv. Stačí, ak nám dáte svoju e-mailovú adresu a pošleme vám e-mail s odkazom na obnovenie hesla, ktorý vám umožní vybrať si nové.",
        "submit": "Potvrdiť"
    },
    "verify_email": {
        "greeting": "Ďakujeme za registráciu! Predtým, ako začnete, prosím overite svoju e-mailovú adresu kliknutím na odkaz, ktorý sme vám práve poslali e-mailom. Ak ste email nedostali, radi Vám pošleme ďalší.",
        "resend_email": "Zaslať nový overovací email",
        "new_link": "Na e-mailovú adresu, ktorú ste uviedli pri registrácii, bol odoslaný nový overovací odkaz."
    },
    "log_out": "Odhlásiť sa",
    "button": {
        "create": "Vytvoriť",
        "save_draft": "Uložiť návrh",
        "approve": "Schváliť",
        "save": "Uložiť",
        "submit": "Odovzdať",
        "delete": "Vymazať",
        "review": "Hodnotiť",
        "advance": "Posunúť",
        "export": "Exportovať údaje do súboru Excel",
        "certificate": "Generovať certifikát",
        "reverify": "Opätovne odoslať overovací email",
        "send_certificate": "Odoslať certifikát",
        "change-round": "Presunúť prihlášku do iného kola",
        "generate_rounds": "Generovať súťažné kolá"
    },
    "create_start_list": {
        "title": "Generovať štartovaciu listinu",
        "confirm": "Generovať",
        "desc": "Súťažné kolo obsahuje ",
        "papers_single": "{0} prihlášku",
        "papers_multi": "{0} prihlášky",
        "papers_many": "{0} prihlášok"
    },
    "create_finish_list": {
        "title": "Generovať výsledkovú listinu",
        "confirm": "Generovať",
        "desc": "Súťažné kolo obsahuje ",
        "papers_single": "{0} prihlášku",
        "papers_multi": "{0} prihlášky",
        "papers_many": "{0} prihlášok"
    },
    "confirms_ratings": {
        "button": "Potvrdiť výsledky",
        "title": "Vyhodnotenie súťažného kola",
        "confirm": "Potvdiť"
    },
    "confirm_password": "Potvrdiť",
    "tooltip": {
        "max_papers": "Dosiahli ste limit prihlášok za tento ročník súťaže",
        "no_contest_year": "Ročník súťaže nie je aktívny",
        "no_contest_round": "Súťažné kolo sa nenašlo",
        "past_deadline": "Súťažné kolo už neprijíma nové prihlášky.",
        "already_created": "Súťažné kolá pre tento ročník už boli vytvorené",
        "already_advanced": "Bol dosiahnutý maximálny počet posunutých prihlášok za tento odbor"
    },
    "no_results": "Neboli nájdené žiadne výsledky",
    "no_selected_rounds": "Nie sú vybrané žiadne položky",
    "toast": {
        "info": {
            "preparing_data": "Pripravujeme údaje..."
        },
        "warn": {
            "some_certificates_failed": "Niektoré certifikáty sa nepodarilo odoslať."
        },
        "error": {
            "submit_paper": "Naskytla sa chyba pri odovzdávaní prihlášky",
            "validate_form": "Prosím skontrolujte vyplnené polia",
            "approve_paper": "Chyba pri schvaľovaní prihlášky",
            "approve_generation": "Chyba pri generovaní súťažných kôl",
            "next_round": "Pre prácu sa nepodarilo nájsť postupné kolo",
            "review_paper": "Nastala chyba pri hodnotení práce",
            "fetch_data": "Chyba pri získávaní údajov zo servera",
            "export": "Chyba pri exportovaní údajov",
            "download": "Chyba pri sťahovaní súborov",
            "certificate": "Chyba pri generovaní certifikátu",
            "submit": "Chyba pri ukladaní údajov",
            "coauthor_is_author": "Zadaný užívateľ je autorom prihlášky",
            "coauthor_exists": "Zadaný spoluautor je už k prihláške pridelený",
            "coauthor_not_found": "Zadaný užívateľ nebol nájdený",
            "coauthor_no_permission": "Nedostatočné práva na odstránenie spoluautora",
            "access_denied": "Nemáte dostatočne práva na zobrazenie tejto stránky",
            "paper_already_submitted": "Pre tento odbor ste už jednu prihlášku podali",
            "root_admin_role": "Rolu administrátora nemožno odstrániť kmeňovému administrátorovi",
            "no_contest_year": "Ročník súťaže sa nenašiel",
            "no_contest_round": "Súťažné kolo sa nenašlo",
            "inactive_round": "Súťažné kolo momentálne neprijíma nové prihlášky",
            "no_next_round": "Pre prihlášku sa nenašlo postupné kolo",
            "unknown_category": "Neznámy typ štatistiky",
            "stats": "Chyba pri sťahovaní štatistík",
            "past_deadline": "Súťažné kolo už neprijíma nové prihlášky.",
            "user_already_verified": "Užívateľ bol už overený",
            "resend_verification": "Chyba pri odosielaní overovacieho emailu",
            "bug_report": "Chyba pri odosielaní správy",
            "submit_school": "Chyba pri odosielaní správy",
            "rate_limit": "Dosiahli ste maximálny počet žiadostí, skúste znova neskôr, prosím",
            "no_submit_round": "Nenašlo sa kolo pre zaradenie prihlášky",
            "submit_round_started": "Kolo pre zaradenie už neprijíma nové prihlášky",
            "create_start_list": "Chyba pri generovaní štartovacej listiny",
            "create_finish_list": "Chyba pri generovaní výsledkovej listiny",
            "create_contest_round": "Chyba pri vytváraní súťažného kola",
            "judge_not_found": "Porotca so zadaným emailom sa nenašiel",
            "get_round_ratings": "Chyba pri načítavaní hodnotení kôl",
            "finalize_round": "Chyba pri vyhodnocovaní súťažného kola",
            "next_round_past_deadline": "Vyššie súťažné kolo už neprijíma nové prihlášky",
            "issuing_certificate": "Nastala chyba pri odosielaní certifikátu",
            "no_nationwide_contest_round": "Nenašlo sa celoštátne kolo",
            "category_already_advanced": "Z tohto súťažného odboru už bola jedna práca posunutá",
            "transfer_rounds": "Chyba pri načítavaní dostupných kôl",
            "transfer_paper": "Chyba pri presúvaní prihlášky do súťažného kola",
            "duplicate_reviewer": "Porotca je už súčasťou hodnotiacej komisie",
            "contest_category_not_found": "Zadaný súťažný odbor sa nenašiel",
            "duplicate_rating": "Toto umiestnenie už bolo udelené inej prihláške",
            "paper_review_inactive": "Hodnotenie prác nie je aktívne",
            "browse_archive": "Chyba pri zobrazení archívu súťaže",
            "leave_archive": "Chyba pri opúšťaní archívu súťaže",
            "no_downloaded_files": "Zvolené prihlášky neobsahovali žiadne súbory na stiahnutie",
            "publish_ratings": "Chyba pri zverejňovaní výsledkov kola",
            "unpublish_ratings": "Chyba pri skrytí výsledkov kola",
            "invalid_school_file_format": "Nesprávny formát súboru číselníku škôl",
            "invalid_region_file_format": "Nesprávny formát súboru číselníku regiónov",
            "invalid_school_types_file_format": "Nesprávny formát súboru typov škôl",
            "seed_schools": "Chyba pri aktualizácii databázy škôl",
            "advance_papers": "Chyba pri posune prihlášok",
            "send_certificates": "Nastala chyba pri odosielaní certifikátov",
            "prune_users": "Chyba pri výmaze užívateľov",
            "change_round_dates": "Chyba pri zmene dátumov kôl",
            "import_schools": "Chyba pri aktualizácii škôl",
            "mock_template": "Chyba pri generovaní vzoru",
            "mass_email_send": "Chyba pri odosielaní správy",
            "cert-copy": "Chyba pri generovaní odpisu",
            "cert_not_found": "Súťažiaci sa nenašiel",
            "forward_users": "Prenesenie užívateľov zlyhalo",
            "no_delete_student": "Študenta s prihláškami nie je možné vymazať",
            "add_reviewable": "Chyba pri priradení súťažného kola",
            "judge_reviewable_exists": "Kolo už bolo raz priradené porotcovi",
            "invalid_county_round_creation": "Nemáte právo na vytvorenie kola pre tento okres"
        },
        "success": {
            "register": "Registrácia prebehla úspešne",
            "change_password": "Heslo bolo úspešne zmenené",
            "reset_password": "Heslo bolo úspešne zmenené",
            "create_password": "Heslo bolo úspešne vytvorené",
            "delete_paper": "Prihláška bola odstránená",
            "delete_year": "Ročník súťaže bol odstránený",
            "delete_user": "Užívateľ bol odstránený",
            "delete_contact": "Kontakt bol odstránený",
            "delete_round": "Kolo bolo odstránené",
            "approve_paper": "Prihláška bola schválená",
            "approve_generation": "Generovanie súťažných kôl prebehlo úspešne",
            "review_paper": "Prihláška bola úspešne ohodnotená.",
            "export": "Údaje boli úspešne exportované",
            "certificate": "Certifikát bol úspešne vytvorený",
            "submit": "Údaje boli úspešne uložené",
            "stats": "Štatistiky sú pripravené",
            "submit_paper": "Prihláška bola odovzdaná",
            "resend_verification": "Email na overenie bol odoslaný",
            "bug_report": "Chyba bola úspešne nahlásená. Ďakujeme",
            "submit_school": "Správa bola úspešne odoslaná. Ďakujeme",
            "create_start_list": "Štartovacia listina bola úspešne vygenerovaná",
            "create_finish_list": "Výsledková listina bola úspešne vygenerovaná",
            "create_contest_round": "Súťažné kolo bolo úspešne vytvorené",
            "finalize_round": "Súťažné kolo bolo úspešne vyhodnotené",
            "issuing_certificate": "Certifikát bol úspešne odoslaný",
            "add_reviewer": "Porotca bol úspešne pridaný do odbornej hodnotiacej komisie",
            "remove_reviewer": "Porotca bol úspešne odstránený z odbornej hodnotiacej komisie",
            "browse_archive": "Zobrazuje sa archív súťaže",
            "leave_archive": "Opustili ste archív súťaže",
            "download": "Súbory boli úspešne stiahnuté",
            "publish_ratings": "Výsledky kola boli zverejnené",
            "unpublish_ratings": "Výsledky kola boli skryté",
            "seed_schools": "Databáza škôl bola úspešne aktualizovaná",
            "advance_papers": "Prihlášky boli úspešne posunuté",
            "send_certificates": "Certifikáty boli úspešne odoslané",
            "prune_users": "Neaktívni užívatelia boli vymazaní",
            "change_round_dates": "Dátumy kôl boli zmenené",
            "import_schools": "Zoznam škôl bol úspešne aktualizovaný",
            "mass_email_send": "Hromadná správa bola odoslaná",
            "cert-copy": "Odpis bol úspešne vygenerovaný",
            "add_reviewable": "Súťažné kolo bolo pridané",
            "remove_reviewable": "Súťažné kolo bolo odobrané",
            "forward_users": "Užívatelia boli úspešne prenesení"
        }
    },
    "user_role": {
        "student": "Študent",
        "judge": "Porotca",
        "garant": "Garant",
        "vsk": "VSK",
        "admin": "Administrátor",
        "roundmanager": "Správca CK",
        "none": "Bez role"
    },
    "user_tabs": {
        "profile": "Profil",
        "management": "Správa"
    },
    "user_form": {
        "empty_roles": "Žiadne role"
    },
    "user_permission": {
        "type": {
            "create": "Vytváranie",
            "view": "Zobrazenie",
            "edit": "Úprava",
            "delete": "Odstraňovanie",
            "approve": "Schvaľovanie"
        },
        "type_static": {
            "create": "vytvoriť",
            "view": "zobraziť",
            "edit": "upraviť",
            "delete": "odtrániť",
            "approve": "schváliť"
        },
        "name": {
            "rounds": "Súťažných kôl",
            "papers": "Prihlášok",
            "judges": "Porotcov",
            "garants": "Garantov",
            "profiles": "Profilov",
            "vsks": "VSK",
            "users": "Užívateľov",
            "years": "Ročníkov Súťaže"
        },
        "name_static": {
            "rounds": "súťažné kolá",
            "papers": "prihlášok",
            "judges": "porotcov",
            "garants": "garantov",
            "profiles": "profily",
            "vsks": "VSK",
            "users": "užívateľov",
            "years": "ročníky súťaže"
        },
        "papers_view_own": "Zobrazenie Vlastných Prihlášok",
        "papers_view_own_static": "zobraziť vlastné prihlášky",
        "papers_view_students": "Zobrazenie Prihlášok Študentov",
        "papers_view_students_static": "zobraziť prihlášky študentov",
        "papers_view_region": "Zobrazenie Krajských Prihlášok",
        "papers_view_region_static": "zobratiť prihlášky svojho kraja",
        "rounds_info_view": "Zobrazenie Údajov Kola",
        "rounds_info_view_static": "zobraziť údaje kola",
        "rounds_participants_view": "Zobrazenie Účastníkov Kola",
        "rounds_participants_view_static": "zobraziť účastníkov Kola",
        "users_view_students": "Zobrazenie študentov",
        "users_view_students_static": "zobraziť študentov",
        "ability": "Môže"
    },
    "modal_delete": {
        "prefix": "Chcete naozaj vymazať {0}?",
        "confirm": "Vymazať",
        "user": "užívateľa {0}",
        "vsk": "VSK {0}",
        "paper": "prihlášku {0}",
        "judge": "porotcu {0}",
        "garant": "garanta {0}",
        "contest_year": "ročník súťaže {0}",
        "contest_round": "súťažné kolo {0}",
        "contact": "kontakt {0}",
        "round-manager": "správcu CK {0}"
    },
    "pagination": {
        "showing": "Zobrazuje sa",
        "to": "až",
        "from": "z",
        "results": "výsledkov"
    },
    "create_first_paper": "Vytvoriť prihlášku",
    "cancel": "Zrušiť",
    "close": "Zatvoriť",
    "group": "Zoskupiť",
    "no_undo": "Táto voľba sa nedá vrátiť späť.",
    "advance": {
        "title": "Posunúť prihlášku",
        "desc": "Týmto prihlášku záväzne ohodnotíte, čím sa posunie do ďaľšieho kola. Prosím, vyberte svoje hodnotenie kliknutím na tlačidlo nižšie.",
        "advance": "Postupuje",
        "deny": "Nepostupuje",
        "confirm_advance": "Potvrdenie postupu",
        "confirm_advance_desc": "Týmto výberom záväzne potvrdzujete postup prihlášky do nižšie uvedeného kola. Táto voľba sa nedá vrátiť späť."
    },
    "review": {
        "title": "Ohodnotiť prihlášku",
        "desc": "Týmto prihlášku záväzne ohodnotíte, čím sa posunie do ďaľšieho kola. Prosím, vyberte svoje hodnotenie kliknutím na tlačidlo nižšie.",
        "confirm": "Ohodnotiť",
        "deny": "Nepostupuje",
        "confirm_advance": "Potvrdenie postupu",
        "confirm_advance_desc": "Týmto výberom záväzne potvrdzujete postup prihlášky do nižšie uvedeného kola. Táto voľba sa nedá vrátiť späť."
    },
    "confirm": "Potvrdiť",
    "hide_empty_rounds": "Skryť prázdne kolá",
    "required_field": "*Povinný údaj",
    "show_inactive_schools": "Zaniknuté",
    "config_form": {
        "round_system": "Systém kôl",
        "paper_max_attachment_size": "Maximálna veľkosť súboru práce a prílohy v KB",
        "paper_category_advancement_limit": "Počet prác v súťažnom odbore, ktoré môžu postúpiť zo školského alebo okresného do krajského kola. popr. okresného.",
        "paper_rating_advancement_limit": "Počet postupujúcich prác za súťažný odbor z krajského do celoštátneho kola (max. 5)",
        "templates": "Šablóny diplomov a certifikátov",
        "copy_templates": "Šablóny odpisov diplomov a certifikátov",
        "diploma_template": "Predvolená šablóna diplomov",
        "certificate_template": "Predvolená šablóna certifikátov",
        "diploma_copy_template": "Šablóna odpisov diplomov",
        "certificate_copy_template": "Šablóna odpisov certifikátov",
        "data_registries": "Číselníky a registre",
        "schools_csv_url": "Adresa číselníka škôl",
        "lists": "Šablóny listín",
        "finish_list_template": "Šablóna výsledkovej listiny"
    },
    "export": {
        "select_cols": "Vyberte stľpce, ktoré chcete zahrnúť",
        "confirm": "Exportovať"
    },
    "paper_timeline_action": {
        "create": "Vytvoril prihlášku",
        "create_draft": "Vytvoril návrh prihlášky",
        "submit_draft": "Odovzdal prihlášku",
        "update": "Upravil prihlášku",
        "approve": "Schválil prihlášku",
        "round_add": "Pridal prihlášku do kola",
        "round_advance": "Posunul prihlášku do kola",
        "round_transfer": "Premiestnil prihlášku do kola",
        "judge_view": "Zobrazil prihlášku",
        "review": "Udelil hodnotenie",
        "delete_review": "Odstránil hodnotenie"
    },
    "certificate": {
        "certifikat_uspesny_riesitel": "Certifikát úspešného riešiteľa",
        "diplom": "Diplom"
    },
    "certificate_template": {
        "place": "Umiestnenie (poradie)",
        "issue_place": "Miesto vydania"
    },
    "generate": "Generovať",
    "add_school": {
        "title": "Nenašiel som svoju školu",
        "heading": "Pridať školu",
        "description": "Pokiaľ ste v našom zozname svoju školu nenašli, je možné, že ešte nie je dostupná v číselníku škol. Prosím, pošlite nám jej údaje a my náš zoznam aktualizujeme.",
        "school_name": "Názov školy",
        "school_placeholder": "Zadajte celý názov školy aj s adresou",
        "submit": "Odoslať",
        "submitting": "Odosielanie..."
    },
    "approve_paper": {
        "title": "Schváliť prihlášku",
        "submit": "Schváliť",
        "submitting": "Schvaľovanie..."
    },
    "generate_rounds": {
        "title": "Generovať súťažné kolá",
        "content": "Zvolením sa vygeneruje nasledovný počet súťažných kôl",
        "school_rounds": "Školských kôl",
        "county_rounds": "Okresných kôl",
        "region_rounds": "Krajských kôl",
        "nationwide_round": "Celoštátne kolo",
        "submit": "Generovať",
        "submitting": "Generovanie..."
    },
    "transfer_paper": {
        "title": "Presunúť prihlášku do kola",
        "detail": "Vyberte nové kolo pre prihlášku",
        "round": {
            "school": "Školské kolo",
            "county": "Okresné kolo",
            "region": "Krajské kolo",
            "nationwide": "Celoštátne kolo"
        },
        "unavailable": "nie je k dispozícii",
        "processing": "Prebieha presúvanie prihlášky..."
    },
    "view_archive": {
        "title": "Prehliadať archív súťaže",
        "submit": "Zobraziť",
        "submitting": "Načítavanie...",
        "open_button": "Archív prác"
    },
    "active_archive": {
        "title": "Zobrazuje sa archív súťaže",
        "submit": "Opustiť archív",
        "submitting": "Načítavanie..."
    },
    "template_type": {
        "diploma": "Diplom",
        "certificate": "Certifikát",
        "other": "Iná"
    },
    "template_guide": {
        "mock_template": "Nahrajte šablónu na otestovanie"
    },
    "mass_email": {
        "region_tooltip": "Nakoľko role 'Administrátor' a 'Správca CK' nie sú naviazané na kraj, tento výber ich neovplyvní."
    },
    "students": {
        "active_only": "Aktuálny ročník",
        "active_only_tooltip": "Zobraziť len študentov, ktorý sa účastnia aktuálneho súťažného ročníka"
    }
}
